<template>
	<ValidationObserver ref="observer" v-slot="{ passes }">
		<form @submit.prevent="passes(() => {})" autocomplete="disabled" onkeydown="return event.key != 'Enter';">
			<div class="mdl-grid">
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
					<label>{{ T("email") }}</label>
					<ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
						<input v-model.trim="username" type="text" class="mdl-textfield__input" />
						<span class="error">{{ errors[0] }}</span>
					</ValidationProvider>
				</div>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
					<label>{{ T("password") }}</label>
					<ValidationProvider name="password" rules="required" v-slot="{ errors }">
						<input v-model.trim="password" type="password" class="mdl-textfield__input" />
						<span class="error">{{ errors[0] }}</span>
					</ValidationProvider>
				</div>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m error" v-if="!isLoginValid">
					<span>{{ T("ticketing_email_or_password_incorrect") }}</span>
				</div>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-mlinks">
					<a @click="onForgotPassword">{{ T("ticketing_forgot_password") }}</a>
					<a @click="onRegister">{{ T("register") }}</a>
				</div>
			</div>
		</form>
	</ValidationObserver>
</template>

<script>
	import {
		ValidationObserver,
		ValidationProvider
	} from "vee-validate";
	import {
		EventBus
	} from "../../scripts/_eventBus.js";
	import defaultMixin from "../../mixins/default";

	export default {
		name: "d21-modal-login",
		mixins: [defaultMixin],
		components: {
			ValidationObserver,
			ValidationProvider
		},
		data() {
			return {
				username: '',
				password: '',
				isLoginValid: true
			}
		},
		created() {
			EventBus.$on("show:login", (status) => {
				if (!status) this.cleanInputFields();
			});
			EventBus.$on("loginSuccess", (status) => {
				if (!status) this.isLoginValid = false;
				else this.isLoginValid = true;
			});
		},
		methods: {
			cleanInputFields() {
				this.username = '';
				this.password = '';
			},
			updateInputs() {
				this.$emit('update:content', {
					username: this.username,
					password: this.password
				});
			},
			onForgotPassword() {
				this.$modals.hide('login');
				this.$modals.show('forgot-password');
			},
			onRegister() {
				this.$modals.hide('login');
				this.$modals.show('register');
			}
		},
		watch: {
			username() {
				this.updateInputs();
			},
			password() {
				this.updateInputs();
			}
		}
	}
</script>